import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Content from '../Category/Content/Content'
import Nav from '../Nav/nav'
import Nav2 from '../Nav2/Nav2'
import './MultiSelect.css'




const Search = () => {
    const [content, setContent] = useState([])
    const [seacrhTerm, setseacrhTerm] = useState("")

    const fetchSeacrh = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/newest'
        )
        setContent(data.data)
    }

    useEffect(() => {
        fetchSeacrh()
    }, [])

    return (
        <div>
            <Nav2 />
            <input
                className="input-search-baru-2"
                type="text"
                placeholder="search..."
                onChange={(event) => {
                    setseacrhTerm(event.target.value)
                }}
            />
            {
                content && content.filter((c) => {
                    if (seacrhTerm == "") {
                        return c
                    } else if (c.donationName.toLowerCase().includes(seacrhTerm.toLowerCase())) {
                        return c
                    }
                })
                    .map((c) => (
                        <Content
                            key={c.id}
                            name={c.donationName}
                            need={c.donationNeeded}
                            expired={c.expiredDate}
                            image={c.image}
                        />
                    ))
            }
        </div>
    )
}

export default Search
